import KwTimepicker from './KwTimepicker.vue';

export default KwTimepicker;



// WEBPACK FOOTER //
// ./src/components/UI/KwTimepicker/index.js